import React from 'react'
import propTypes from 'prop-types'
import { monthNames } from '../../helpers/helpers'

const SelectMonth = ({ date, selectMonth }) => {
  const selectMonthHandler = (e) => {
    e.preventDefault()

    selectMonth(e.target.value)
  }

  const options = monthNames.map((name, i) => {
    const year = date.format('YYYY')
    const curMonth = i > 8 ? i + 1 : '0' + (i + 1)
    const dateStr = `${year}-${curMonth}-01`
    return (
      <option key={name} value={dateStr}>
        {name}
      </option>
    )
  })

  return (
    <select 
    defaultValue={date.format('YYYY-MM-DD')} 
    onBlur={e => selectMonthHandler(e)}>
    {options}
    </select>
  )
}

SelectMonth.propTypes = {
  date: propTypes.object,
  selectMonth: propTypes.func
}

export default SelectMonth


// WEBPACK FOOTER //
// ./src/components/SelectMonth/SelectMonth.js